import React from 'react';
import styles from './QueryBar.module.scss';

export default function QueryBar({ children, button = true }) {
  const classes = [styles.wrap, button ? styles.button : ''].join(' ');
  return <header className={classes}>{children}</header>;
}
